// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b6435061","142":"cdb7262a","162":"0510eae9"}[chunkId] + ".chunk.js";
};